// extracted by mini-css-extract-plugin
module.exports = {"container":"e_-A","msrp":"e_aB","save":"e_bB","discount":"e_cB","price":"e_dB"};